// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { action, observable } from 'mobx';
// typings
import { UnderlyingChartsApplicable, UnderlyingChartsList } from './typings';

export default class UnderlyingChartsStore {
  @observable isUnderlyingChartsChecked = false;

  @observable isUnderlyingChartsApplicable: UnderlyingChartsApplicable = {};

  @observable underlyingChartsList: UnderlyingChartsList = [];

  @action setIsUnderlyingChartsChecked = (value: boolean) => {
    this.isUnderlyingChartsChecked = value;
  };

  @action setUnderlyingChartsList = (value: UnderlyingChartsList) => {
    this.underlyingChartsList = value;
  };

  @action setIsUnderlyingChartsApplicable = (
    exchangeToken: string,
    value: boolean,
  ) => {
    this.isUnderlyingChartsApplicable[exchangeToken] = value;
  };
}
